import { LEGAL, CONTACT_EMAIL } from "../config/site";
import Seo from "../components/Seo";

function Shell({ intro, children, testid }) {
  return (
    <>
      <section className="bg-paper pb-10 pt-14 lg:pb-12 lg:pt-20">
        <div className="container-site">
          <h1 className="max-w-3xl font-display text-3xl font-extrabold tracking-tight text-antracite sm:text-4xl">
            {testid === "page-privacy" && "Privacy Policy"}
            {testid === "page-cookie" && "Cookie Policy"}
            {testid === "page-informazioni" && "Informazioni sul sito"}
          </h1>
          {intro && <p className="mt-4 max-w-2xl text-sm leading-relaxed text-muted">{intro}</p>}
        </div>
      </section>
      <section className="pb-24">
        <div className="container-site max-w-3xl space-y-10 text-sm leading-relaxed text-antracite-soft" data-testid={testid}>
          {children}
        </div>
      </section>
    </>
  );
}

function H2({ children }) {
  return <h2 className="font-display text-lg font-bold text-antracite sm:text-xl">{children}</h2>;
}

function Placeholder() {
  return (
    <p className="rounded-xl bg-fog p-4 text-xs italic text-muted">
      I dati identificativi del titolare verranno pubblicati in questa sezione prima dell’attivazione definitiva del sito.
    </p>
  );
}

export function PrivacyPolicy() {
  return (
    <>
      <Seo
        title="Privacy Policy"
        description="Informativa privacy per le richieste inviate tramite il sito DN STUDIO TECNICO."
        path="/privacy-policy"
      />
      <Shell
        intro="Informativa resa ai sensi del Regolamento UE 2016/679 (GDPR) per i dati inviati tramite il form di richiesta."
        testid="page-privacy"
      >
        <div>
          <H2>Chi tratta i dati</H2>
          {LEGAL.titolare ? (
            <p className="mt-3">
              Titolare del trattamento: {LEGAL.titolare}. Contatti: {LEGAL.pec ? `PEC ${LEGAL.pec}` : "tramite il form di questo sito"}.
            </p>
          ) : (
            <div className="mt-3">
              <Placeholder />
            </div>
          )}
          <p className="mt-3">
            Per qualsiasi comunicazione relativa ai dati personali:{" "}
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              data-testid="privacy-contact-email"
              className="font-medium text-petrolio underline underline-offset-2"
            >
              {CONTACT_EMAIL}
            </a>
            .
          </p>
        </div>
        <div>
          <H2>Quali dati trattiamo</H2>
          <p className="mt-3">
            Esclusivamente i dati che decidi di inserire nel form di richiesta: nome e cognome, email, telefono (facoltativo),
            città e provincia dell’intervento, servizio richiesto e descrizione della pratica. Per l’invio dei messaggi
            utilizziamo un servizio email professionale: nessun dato viene salvato su questo sito o in un database.
          </p>
        </div>
        <div>
          <H2>Per quali finalità</H2>
          <p className="mt-3">
            Unicamente per dare seguito alla tua richiesta: ricontattarti, chiedere eventuali approfondimenti o documentazione e,
            se necessario, proporre l’attività da svolgere. Nessuna newsletter, nessuna attività di marketing, nessuna
            profilazione, nessun sistema di tracciamento.
          </p>
        </div>
        <div>
          <H2>Base giuridica e natura del conferimento</H2>
          <p className="mt-3">
            Il conferimento dei dati avviene su tua iniziativa ed è espresso dal consenso richiesto nel form (art. 6.1.a GDPR).
            Fornirli è facoltativo, ma senza i dati minimi non possiamo ricontattarti.
          </p>
        </div>
        <div>
          <H2>Conservazione</H2>
          <p className="mt-3">
            I dati sono conservati solo per il tempo necessario a gestire la richiesta e i conseguenti adempimenti. L’invio del
            modulo è una richiesta di contatto: non costituisce conferimento di incarico e non genera obblighi economici.
          </p>
        </div>
        <div>
          <H2>I tuoi diritti</H2>
          <p className="mt-3">
            Puoi chiedere in ogni momento l’accesso, la rettifica, la cancellazione, la limitazione e la portabilità dei tuoi
            dati, oppure opporti al trattamento (artt. 15–22 GDPR). Hai inoltre il diritto di rivolgere reclamo al Garante per la
            protezione dei dati personali. Per esercitare i diritti, scrivici tramite il form di questo sito.
          </p>
        </div>
      </Shell>
    </>
  );
}

export function CookiePolicy() {
  return (
    <>
      <Seo
        title="Cookie Policy"
        description="Cookie policy del sito DN STUDIO TECNICO: nessun cookie di profilazione o tracciamento."
        path="/cookie-policy"
      />
      <Shell
        intro="Questo sito non utilizza cookie di profilazione, né sistemi di analytics o tracciamento."
        testid="page-cookie"
      >
        <div>
          <H2>Cosa usiamo davvero</H2>
          <p className="mt-3">
            Il sito utilizza solo memorizzazioni tecniche strettamente necessarie al suo funzionamento e alla sicurezza delle
            comunicazioni. Non installiamo cookie pubblicitari, cookie statistici o di profilazione, e non raccogliamo dati di
            navigazione per finalità commerciali.
          </p>
        </div>
        <div>
          <H2>Perché non vedi un banner</H2>
          <p className="mt-3">
            Poiché vengono utilizzate esclusivamente tecnologie strettamente necessarie, la normativa non richiede un consenso
            preventivo: per questo il sito non mostra alcun banner cookie.
          </p>
        </div>
        <div>
          <H2>Ulteriori informazioni</H2>
          <p className="mt-3">
            Per tutto ciò che riguarda i dati personali inviati tramite il form, consulta la Privacy Policy del sito.
          </p>
        </div>
      </Shell>
    </>
  );
}

export function Informazioni() {
  return (
    <>
      <Seo
        title="Informazioni sul sito"
        description="Informazioni e condizioni d’uso del sito DN STUDIO TECNICO."
        path="/informazioni"
      />
      <Shell
        intro="Che cosa è questo sito, che cosa fa e che cosa, deliberatamente, non fa."
        testid="page-informazioni"
      >
        <div>
          <H2>Natura del sito</H2>
          <p className="mt-3">
            Questo sito ha finalità esclusivamente informative: è la vetrina professionale di uno studio tecnico che opera in
            tutta Italia. Non vengono venduti servizi online, non esistono acquisti, pagamenti, ordini o sottoscrizioni di
            contratti tramite il sito.
          </p>
        </div>
        <div>
          <H2>Le richieste tramite form</H2>
          <p className="mt-3">
            L’invio del modulo di richiesta rappresenta solo una richiesta di contatto: non costituisce conferimento di
            incarico professionale e non genera obblighi economici. Ogni eventuale incarico viene definito direttamente con lo
            studio, al di fuori del sito, con modalità e condizioni chiare prima dell’avvio.
          </p>
        </div>
        <div>
          <H2>Contenuti informativi</H2>
          <p className="mt-3">
            I contenuti del sito hanno scopo informativo generale e non costituiscono consulenza sul caso concreto: ogni
            pratica ha caratteristiche proprie e va valutata singolarmente. Ci impegniamo a mantenere le informazioni accurate
            e aggiornate.
          </p>
        </div>
        <div>
          <H2>Dati identificativi</H2>
          <p className="mt-3">
            I dati identificativi e professionali del titolare (requisiti professionali, iscrizione al Collegio, PEC) sono
            pubblicati nelle note legali del sito, solo dove strettamente necessario.
          </p>
          {LEGAL.titolare || LEGAL.piva || LEGAL.pec || LEGAL.collegio ? (
            <p className="mt-3">
              {[LEGAL.titolare, LEGAL.piva && `P.IVA ${LEGAL.piva}`, LEGAL.collegio, LEGAL.pec && `PEC ${LEGAL.pec}`]
                .filter(Boolean)
                .join(" · ")}
            </p>
          ) : (
            <div className="mt-3">
              <Placeholder />
            </div>
          )}
        </div>
        <div>
          <H2>Diritto applicabile</H2>
          <p className="mt-3">
            L’uso del sito è regolato dal diritto italiano. Questo sito non è gestito da una società né da uno studio
            associato: è il punto di contatto online dell’attività professionale del titolare.
          </p>
        </div>
      </Shell>
    </>
  );
}
